import NextLink from "next/link";

export function Link(props: any) {
  const { label, icon, ...rest } = props;

  return (
    <NextLink {...rest} prefetch={false} className={"inline text-blue underline"}>
      {label}
    </NextLink>
  );
}
